import * as React from 'react';
import { useMemo } from 'react';
import NavShell from './NavShell';
import HomeIcon from '@mui/icons-material/Home';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

function DriverNavBar({ children }) {
  const navItems = useMemo(() => [
    { key: 'home', label: 'Home', icon: <HomeIcon />, path: '/home' },
    { key: 'gatekeeper', label: 'Obecności', icon: <EventAvailableIcon />, path: '/driverGateKeeper' },
  ], []);

  return (
    <NavShell
      storageKeyPrefix="driver"
      profileHref="/DriverProfile"
      allowedProfileTypes={['driver']}
      navItems={navItems}
    >
      {children}
    </NavShell>
  );
}

export default DriverNavBar;
